import { isValidPhoneNumber } from "react-phone-number-input";
import { isValidEmail } from "../../utils/isValidEmail";
import mapKnownValues from "../../utils/mapKnownValues";

export type PlanAdministratorResponse = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  planAdministratorId: number;
  tenantId: number;
  workEmail: string;
};

export class PlanAdministrator {
  firstName = "";
  lastName = "";
  phoneNumber = "";
  planAdministratorId = -1;
  tenantId = -1;
  workEmail = "";

  _originalData = "";

  constructor(params: Partial<PlanAdministrator> = {}) {
    mapKnownValues(this, params);
    if (this.phoneNumber === "+1") this.phoneNumber = "";
    if (!params?._originalData) {
      this._originalData = JSON.stringify({
        ...this,
        _originalData: undefined,
      });
    }
  }

  get hasChanged() {
    return (
      JSON.stringify({
        ...this,
        _originalData: undefined,
      }) !== this._originalData
    );
  }

  get isCompleted() {
    return (
      this.firstName &&
      this.lastName &&
      this.phoneNumber &&
      isValidPhoneNumber(this.phoneNumber) &&
      this.workEmail &&
      isValidEmail(this.workEmail)
    );
  }

  static fromAPI(response: PlanAdministratorResponse) {
    return new PlanAdministrator(response);
  }

  toJSONForAPI() {
    return JSON.stringify({
      ...this,
      _originalData: undefined,
    });
  }
}
